<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row align="center" justify="center" class="pa-2 ma-4">
          <v-card width="500px">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t('solicitar_activacion') }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-alert v-model="error.activado" type="error" dismissible dense outlined>
                {{ error.mensaje }}
              </v-alert>
              <v-text-field :label="$t('label_email')" type="email" v-model="email" :rules="[requerido, emailValidar]"
                            prepend-inner-icon="mdi-at"/>
            </v-card-text>
            <v-card-actions>
              <v-row no-gutters class="mt-0">
                <v-col cols="12" class="text-right pr-3">
                  <v-btn color="primary" :disabled="!emailValido()" :loading="solicitando" @click="solicitar()">
                    <span class="mr-2">{{ $t('solicitar') }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {MOSTRAR_DIALOGO_ACEPTACION} from "@/store/store-app";

export default {
  name: 'ReenviarCodigoActivacion',
  components: {},
  data: () => ({
    email: "",
    solicitando: false,
    error: {
      activado: false,
      mensaje: ""
    }
  }),
  methods: {
    requerido(value) {
      return !!value || this.$t('requerido')
    },
    emailValidar(value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || this.$t('req_email')
    },
    emailValido() {
      return this.email.length > 0;
    },
    solicitar() {
      let params = {
        email: this.email
      };

      this.solicitando = true;
      HttpHelper.get("auth/reenvio-codigo-activacion", params)
          .then(() => {
            this.error.activado = false;
            this.$store.dispatch(MOSTRAR_DIALOGO_ACEPTACION, {
              titulo: this.$t('solicitud_completada'),
              color: "success",
              texto: this.$t('solicitud_completada_msg')
            });
            this.email = "";
          })
          .catch((error) => {
            this.error.mensaje = error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                ? error.mensaje : this.$t('error_solicitar');
            this.error.activado = true;
          })
          .finally(() => {
            this.solicitando = false;
          })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

<style lang="scss" scoped>
</style>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "solicitar_activacion": "Solicitar código de activacion",
    "label_email": "Correo electrónico",
    "requerido": "Requerido",
    "req_email": "Correo electrónico incorrecto",
    "error_solicitar": "Ha ocurrido un error desconocido.",
    "solicitar": "Solicitar",
    "solicitud_completada": "Solicitud aceptada",
    "solicitud_completada_msg": "Se va a proceder a reenviarte un correo electrónico para poder activar tu cuenta.",
    "cerrar": "Cerrar"
  }
}
</i18n>
<!-- @formatter:on -->